export const ART_EVENT_ENDPOINTS = {
  ART_EVENTS: '/api/v1/artEventID',
};

export enum ArtEventEndpointQueryKeys {
  GET_ART_EVENTS = 'get-art-events',
  CREATE_ART_EVENT = 'create-art-event',
}
